export type ThrottledCallback<A> = {
  cancel(): void;
  (arg1: A): void;
};
/**
 * Throttles function calls using `requestAnimationFrame`, which ensures that the callback is
 * invoked at most once per animation frame
 */
export const rafThrottle = <A>(callback: (arg1: A) => unknown): ThrottledCallback<A> => {
  let requestId: number | null = null;

  let lastArgs: [A] | undefined;

  const later = (context: Record<any, any>) => () => {
    requestId = null;
    if (lastArgs) {
      callback.apply(context, lastArgs);
    }
  };

  const throttled = function (this: Record<any, any>, ...args: [A]) {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };

  throttled.cancel = () => {
    if (requestId == null) return;
    cancelAnimationFrame(requestId);
    requestId = null;
  };

  return throttled;
};
